const ALLOWED_TAGS = ['P', 'BR', 'STRONG', 'EM', 'U', 'OL', 'UL', 'LI', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'A'];

const REMOVED_TAG_SELECTOR = 'script, style, iframe, object, embed';

const DANGEROUS_ATTRS = ['onclick', 'onerror', 'onload', 'onmouseover', 'onfocus', 'onblur'];

const looksLikeDomain = (str) => {
  return str.startsWith('www.') || /^[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}/.test(str);
};

export const normalizeUrl = (url) => {
  if (!url || typeof url !== 'string') return '';

  const trimmedUrl = url.trim();
  if (!trimmedUrl) return '';

  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;

  if (trimmedUrl.startsWith('/')) {
    return trimmedUrl;
  }

  if (/^https?:\/\//i.test(trimmedUrl)) {
    if (trimmedUrl.startsWith(`${currentProtocol}//${currentHost}/`)) {
      const pathAfterHost = trimmedUrl.replace(`${currentProtocol}//${currentHost}/`, '');
      if (looksLikeDomain(pathAfterHost)) {
        return `https://${pathAfterHost}`;
      }
    }
    return trimmedUrl;
  }

  if (trimmedUrl.startsWith(`//${currentHost}/`)) {
    const pathAfterHost = trimmedUrl.replace(`//${currentHost}/`, '');
    if (looksLikeDomain(pathAfterHost)) {
      return `https://${pathAfterHost}`;
    }
  }

  if (looksLikeDomain(trimmedUrl)) {
    return `https://${trimmedUrl}`;
  }

  return trimmedUrl;
};

export const isExternalUrl = (url) => {
  if (!url || typeof url !== 'string') return false;

  try {
    const currentHost = window.location.hostname;
    const urlObj = new URL(url, window.location.origin);
    return urlObj.hostname !== currentHost && urlObj.hostname !== '';
  } catch {
    return false;
  }
};

export const sanitizeHtml = (html) => {
  if (!html) return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  tempDiv.querySelectorAll(REMOVED_TAG_SELECTOR).forEach((el) => el.remove());

  tempDiv.querySelectorAll('*').forEach((element) => {
    DANGEROUS_ATTRS.forEach((attr) => {
      element.removeAttribute(attr);
    });

    if (element.hasAttribute('href')) {
      const href = element.getAttribute('href') || '';
      const normalizedHref = href.trim().toLowerCase();
      const isBlockedProtocol = /^(\s*)(javascript|data|mailto)\s*:/i.test(normalizedHref);

      if (isBlockedProtocol || !href || href.trim() === '') {
        element.removeAttribute('href');
      } else {
        const normalizedUrl = normalizeUrl(href);

        if (normalizedUrl) {
          element.setAttribute('href', normalizedUrl);
          if (isExternalUrl(normalizedUrl)) {
            element.setAttribute('target', '_blank');
            element.setAttribute('rel', 'noopener noreferrer');
          }
        } else {
          element.removeAttribute('href');
        }
      }
    }

    if (!ALLOWED_TAGS.includes(element.tagName)) {
      const parent = element.parentNode;
      while (element.firstChild) {
        parent.insertBefore(element.firstChild, element);
      }
      parent.removeChild(element);
    }
  });

  return tempDiv.innerHTML;
};
